import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000"}/api`;

export const api = axios.create({
  baseURL: API,
});

const TOKEN_KEY = "bbw_token";
let sessionGeneration = 0;
let observedToken = null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const captureSession = () => {
  const token = getToken();
  if (token !== observedToken) { observedToken = token; sessionGeneration += 1; }
  return { token, generation: sessionGeneration };
};
export const isSessionCurrent = (snapshot) => {
  const current = captureSession();
  return Boolean(snapshot && snapshot.token === current.token && snapshot.generation === current.generation);
};
const notifySessionChange = () => {
  observedToken = getToken();
  sessionGeneration += 1;
  window.dispatchEvent(new Event("bbw:session-change"));
};
export const setToken = (t) => { localStorage.setItem(TOKEN_KEY, t); notifySessionChange(); };
export const clearToken = () => { localStorage.removeItem(TOKEN_KEY); notifySessionChange(); };
window.addEventListener("storage", (event) => {
  if (event.key === TOKEN_KEY || event.key === null) notifySessionChange();
});

export const sessionChangedError = () => Object.assign(new Error("Your admin session changed. Please reload this view."), { code: "ERR_SESSION_CHANGED" });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  cfg.bbwSession = captureSession();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
}, undefined, { synchronous: true });

api.interceptors.response.use(
  (response) => {
    if (response.config?.bbwSession && !isSessionCurrent(response.config.bbwSession)) return Promise.reject(sessionChangedError());
    return response;
  },
  (error) => {
    const detail = error?.response?.data?.detail;
    if (
      error?.response?.status === 401 &&
      (detail === "Token expired" || detail === "Invalid token") &&
      error.config?.bbwSession?.token && isSessionCurrent(error.config.bbwSession)
    ) {
      clearToken();
      window.dispatchEvent(new Event("bbw:auth-expired"));
    }
    return Promise.reject(error);
  },
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) {
    if (err?.code === "ERR_NETWORK" || err?.message === "Network Error") {
      const method = String(err?.config?.method || "").toLowerCase();
      const recovery = ["post", "put"].includes(method)
        ? " If you were publishing, refresh Recent Posts and check Facebook before retrying to avoid a duplicate."
        : "";
      return `Could not reach the website service. Check your connection and try again.${recovery}`;
    }
    return err?.message || "Something went wrong";
  }
  if (d === "Token expired") return "Your admin session expired. Please sign in again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join("; ");
  return String(d);
}
